import React, { useEffect, useRef, useState } from "react";

import './ECatalogScreen.css';
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Breadcrumb, Layout, Menu, Button, PageHeader, Row, Col, Form, Input, Select, Dropdown, Card, List, Space, AutoComplete, Badge, Avatar } from 'antd';
import logo from '../../assets/logotrcs_150px_new1.jpg';
import { AiTwotoneNotification } from "react-icons/ai";
import Products from '../../components/ECatalogComponents/Products';

//import { CartProvider, useCart } from 'react-use-cart';
import { BiCartAlt } from "react-icons/bi";
import { ECatalogNavigation } from "../../components/ECatalogComponents/ECatalogNavigation";
import ProductCatalog from "../../components/ECatalogComponents/ProductCatalog";
import { Stack } from "react-bootstrap";
import { PlusCircleOutlined, FilterOutlined } from '@ant-design/icons';
import LatestViewProduct from "../../components/ECatalogComponents/LatestViewProduct";
import { GetAllMasterCategotryGroup } from "../../Services/e-pro/EcatalogService";
import type { MenuProps } from 'antd';
import $ from 'jquery';
import { useECatalogContext } from "../../Context/ECatalogContext";
import UnAurthorization from "../UnAuthorizePage/UnAurthorization";
import { ECatalogSystemClosed } from "../../components/ECatalogComponents/ECatalogSystemClosed";
import { CartProvider } from "../../Context/CartContext";
import { useUserContext } from "../../Context/UserContext";
type MenuItem = Required<MenuProps>['items'][number];
interface Props { responeConfig?: { pathLoading?: string } }
const { Header, Content, Footer, Sider } = Layout;
const { Option } = Select;

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 10 },
};
const tailLayout = {
    wrapperCol: { offset: 4, span: 10 },
};

export const ECatalogScreen = (props: Props) => {
    const [userData, setUserData] = useUserContext();
    const [productCategory, setProductCategory] = useState<any[]>([]);
    const [categoryItem, setCategoryItem] = useState<MenuItem[]>([]);

    const [menuCategoryOpen, setMenuCategoryOpen] = useState(false);

    const checkEcatalog = useECatalogContext();
    const [isAuthorize, setIsAuthorizeo] = useState(true);
    const [isEditECatalog, setIsEditECatalog] = useState(true);

    const [form] = Form.useForm();
    const history = useHistory();

    const categoryRef = useRef(null);

    const handleClickOutside = (event) => {
        if (categoryRef.current && !categoryRef.current.contains(event.target)) {
            setMenuCategoryOpen(false);
        }
    };

    useEffect(() => {
        $("#root > .navbar-container").hide();
        getProductCategory();
        document.addEventListener('mousedown', handleClickOutside);

    }, [])

    useEffect(() => {
        if (checkEcatalog.roleData != null) {
            setIsAuthorizeo(checkEcatalog.canAccess);
            setIsEditECatalog(checkEcatalog.canEdit);

        }
        console.log(checkEcatalog);
    }, [checkEcatalog]);


    async function getProductCategory() {
        const response = await GetAllMasterCategotryGroup();
        const data = response.data;
        setProductCategory(data);
        //console.log(data); 
        processMenuItem(data);
    }

    const processMenuItem = (source: any) => {
        const items: MenuItem[] = processSubMenuItem(source);
        setCategoryItem(items);
        //console.log(items);

    }
    const processSubMenuItem = (source: any) => {
        const items: MenuItem[] = []
        source.map((item: any) => {
            let menu: MenuItem = {
                key: item.rowID,
                label: item.Text
            }
            if (item.Child.length > 0) {
                menu.children = processSubMenuItem(item.Child);
            }
            items.push(menu);
        })

        return items;
    }
    const handleSearchProduct = (event) => {
        if (event.keyCode === 13) {
            const value = event.target.value.trim();

            // validate อย่างน้อย 3 ตัวอักษร
            if (value.length < 3) {
                alert("Please enter at least 3 characters");
                return;
            }

            //alert('Enter key was pressed' + event.target.value);

            history.push(`/searchproduct?query=` + event.target.value);
        }
    }
    const onCategoryClick: MenuProps['onClick'] = e => {
        //console.log(e);
        let label = e.item.props.elementRef.current.innerText;
        history.push(`/searchproduct?catid=` + e.key + "&cattxt=" + label);
    };
    if (checkEcatalog.isSystemClosed) {
        return (
            <Layout className="layout">
                <ECatalogNavigation />
                <Content style={{ padding: "0 10px" }}>
                    <ECatalogSystemClosed
                        title={checkEcatalog.systemClosedTitle}
                        message={checkEcatalog.systemClosedMessage}
                    />
                </Content>
            </Layout>
        );
    }

    return isAuthorize ? (
        <Layout className="layout">

            <ECatalogNavigation />

            <Content style={{ padding: "0 10px" }}>
                {/* <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>List</Breadcrumb.Item>
            <Breadcrumb.Item>App</Breadcrumb.Item>
          </Breadcrumb> */}
                <Layout>
                    <Sider className="ecatalog-sider" style={{ background: "transparent", /*padding: "0px 10px"*/ fontSize: "20px" }} width={300}
                        breakpoint="lg" collapsedWidth="0" >
                        <Space direction="vertical" size="middle" style={{ display: 'flex', marginTop: "20px" }}>
                            <Form
                                form={form}
                                layout="vertical"
                                className="ecatalog-filter-form"
                            >
                                <Form.Item >
                                    {/* <Button type="primary" className="btnEcatalogPrimary" shape="round" icon={<PlusCircleOutlined />} style={{ fontSize: "16px" }}>คำร้องขอเพิ่มสินค้า</Button> */}
                                    <div style={{ fontSize: "20px", fontWeight: 600 }}>
                                        <FilterOutlined style={{ fontSize: "14px", fontWeight: 600, position: "relative", top: "-3px" }} /> ตัวกรองข้อมูล
                                    </div>
                                </Form.Item>
                                <Form.Item>
                                    <Input
                                        // options={options}
                                        style={{ width: "100%", fontSize: "18px", height: "30px" }}
                                        // onSelect={onSelect}
                                        // onSearch={onSearch}
                                        onKeyDown={(e) => handleSearchProduct(e)}
                                        placeholder="ชื่อสินค้า / ชื่อบริษัท / รหัสสินค้า"
                                    />
                                </Form.Item>
                                {/* <Form.Item label="หมวดหมู่สินค้า" className="custom-form-item">
                                    <Select
                                        showSearch
                                        style={{ width: "100%", fontSize: "18px" }} // ปรับขนาดตัวอักษรสำหรับ Select
                                        placeholder="เลือกหมวดหมู่สินค้า"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                        }
                                        options={categoryOption}
                                    />
                                    
                                    
                                </Form.Item> */}
                            </Form>
                            <nav className="navbar navbar-second navbar-light navbar-expand category-navbar" ref={categoryRef}>
                                <ul className="navbar-nav mr-auto navbar-left">
                                    <li className="nav-item navbar-menu" style={{ width: "100%" }} onClick={() => setMenuCategoryOpen(!menuCategoryOpen)}>
                                        <div className={menuCategoryOpen ? "navbar-menu-list active" : "navbar-menu-list"}  >
                                            {/* <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="list" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-list b-icon bi">
                                            <g><path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"></path></g>
                                            </svg> */}
                                            เลือกหมวดหมู่สินค้า
                                            <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="chevron down" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-chevron-down rotate b-icon bi">
                                                <g><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></g>
                                            </svg>
                                        </div>
                                    </li>
                                </ul>
                                <div className={menuCategoryOpen ? "category-wrapper active" : "category-wrapper"} >
                                    <Menu className="category-menu"
                                        onClick={onCategoryClick}
                                        style={{ width: "100%" }}
                                        //openKeys={['11', '15']}
                                        // selectedKeys={[current]}
                                        mode="vertical"
                                        items={categoryItem}
                                        getPopupContainer={(node) => node.parentNode as HTMLElement}
                                    />
                                </div>

                            </nav>



                        </Space>

                    </Sider>

                    <Content style={{ padding: '0 10px', paddingTop: "15px", minHeight: 280 }}>


                        <Space
                            direction="vertical"
                            size="small"
                            style={{ display: "flex" }}
                        >
                            {/* <Card className="ecatalog-form-search-card card-categorie" bordered={false} title="หมวดหมู่สินค้า" size={"small"} extra={<a href="#">ดูทั้งหมด</a>}>
                                <ProductCatalog />
                            </Card> */}

                            <Card className="ecatalog-form-search-card" bordered={false} title="สินค้าเข้าชมล่าสุด" size={"small"}>
                                {/* <Products showSlide={true} limitItem={2} /> */}
                                <LatestViewProduct />
                            </Card>
                            {/* <Card className="ecatalog-form-search-card" bordered={false} title="สินค้าที่ชอบ" size={"small"}>
                                <Products showSlide={false} limitItem={10} showFavorite={true} showQuantity={isEditECatalog} />
                            </Card>
                            <Card className="ecatalog-form-search-card" bordered={false} title="สินค้าที่เคยซื้อ" size={"small"}>
                                <Products showSlide={false} limitItem={20} showQuantity={isEditECatalog} />
                            </Card> */}
                            <Products showSlide={false} limitItem={20} showQuantity={isEditECatalog} />

                            {/* <Card title="ประกาศจัดซื้อจัดจ้าง" size={"small"} className="announce-card">
                                        <List
                                            size="small"
                                            bordered={false}
                                            dataSource={listData}
                                            renderItem={(item) => <List.Item><a href='#'>{item}</a></List.Item>}
                                        />
                                    </Card>
                                    <Card size={"small"} className="announce-card"
                                        title="ประกาศผลการคัดเลือก"
                                    >
                                        <List
                                            size="small"
                                            bordered={false}
                                            dataSource={listData}
                                            renderItem={(item) => <List.Item><a href='#'>{item}</a></List.Item>}
                                        />
                                    </Card> */}
                        </Space>

                    </Content>
                </Layout>

            </Content>
            {/* <Footer style={{ textAlign: "center" }}>
          Ant Design ©2018 Created by Ant UED
        </Footer> */}
        </Layout>
    ) : (<UnAurthorization />);
};